<template>
  <div>
    <button @click="isModalActive = !isModalActive">Dodaj nową nagrodę</button>
    <div v-if="isModalActive" class="modal-wrapper">
      <b-field label="Name">
        <b-input v-model='name'></b-input>
      </b-field>
      <b-field label="Expanded">
        <b-select v-model="weight" placeholder="Jak często wypada" expanded>
          <option v-for="(option, index) in options" :value="option" :key="index">
            {{ option.name }}
          </option>
        </b-select>
      </b-field>
      <button :disabled="!(name.length > 0 && weight)" @click="addRewardEvent">Add revard</button>
      <button @click="isModalActive = !isModalActive">close</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      isModalActive: false,
      name: '',
      weight: '',
      options: [
        {
          name: 'Bardzo rzadko',
          weighted: 0.001,
        },
        {
          name: 'Rzadko',
          weighted: 0.01,
        },
        {
          name: 'Często',
          weighted: 0.3,
        },
        {
          name: 'Prawie zawsze',
          weighted: 1,
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      addReward: 'loteryStore/addReward',
    }),
    addRewardEvent() {
      this.addReward({ name: this.name, weighted: this.weight });
      this.name = '';
      this.weight = '';
      this.isModalActive = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: $background-light-color;
    padding: 15px;
  }
</style>
